import ApiService from '@/services/api.service'

const ePharmacyItemsReceivedService = {

    getAll(parameter){
        /*const requestData = {
            method: 'get',
            url: "/ItemReceivedHeaders/",

        }*/
         const params = {
                SearchCriteria: parameter.SearchCriteria,
                PageSize: parameter.PageSize,
                PageNumber: parameter.PageNumber,
               // Active: parameter.Active,
                IsVoid: parameter.IsVoid,
                DateFrom: parameter.DateFrom,
                DateTo: parameter.DateTo,
                LocationCodeList: parameter.Location,
                ItemCodeList: parameter.ItemCodeList
            }
        return ApiService.getWithArray('/ItemReceivedHeaders',params);
      //  return ApiService.customRequest(requestData);
    },
    Add(data){
        return ApiService.post(`/ItemReceivedHeaders`, data);
    },
    Delete(Id){
        return ApiService.delete(`/ItemReceivedHeaders/${Id}`);
    },
    Update(Id,data){
        return ApiService.put(`/ItemReceivedHeaders/${Id}`,data);
    },
    Get(Id){
        return ApiService.get(`/ItemReceivedHeaders/${Id}`);
    },
    getAvailableForRelocation(parameters) {
        return ApiService.getWithArray('/ItemReceivedHeaders/Relocation', parameters);
    },
    getTotalsAvailableForRelocation(parameters) {
        return ApiService.getWithArray('/ItemReceivedHeaders/TotalsRelocation', parameters);
    },
    getAvailableForRemoval(parameters) {
        return ApiService.getWithArray('/ItemReceivedHeaders/Removal', parameters);
    },

    getTotalsAvailableForRemoval(parameters) {
        return ApiService.getWithArray('/ItemReceivedHeaders/TotalsRemoval', parameters);
    },

    processRemoval(data) {
        return ApiService.post(`/ItemReceivedHeaders/ProcessRemoval`, data);
    },
    processRelocation(data) {
        return ApiService.post(`/ItemReceivedHeaders/ProcessRelocation`, data);
    },
    getVendors(parameter){
        const requestData = {
            method: 'get',
            url: "/Vendors/",
            params: {
                IsActive: parameter.IsActive,
                SearchCriteria: parameter.SearchCriteria,
                PageSize: parameter.PageSize,
                PageNumber: parameter.PageNumber
            }
        }
        return ApiService.customRequest(requestData);
    },
}

export default ePharmacyItemsReceivedService;
